
if (!customElements.get('main-slider')) {
  class MainSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderList = this.querySelector('.main-slider__list');
      this.buttons = this.querySelectorAll('button[data-switch-action]');

      this.size = this.sliderList.children.length;
      this.slide = this.sliderList.children[0];

      this.currentIndex = 0;

      this.setupButtons();
      this.setupEvents();
    }

    setupButtons() {
      this.buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          this.scrollList(btn);
        })
      })
    }

    setupEvents() {
      const sliderScrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.currentIndex = parseInt(entry.target.dataset.index);
              this.visibilityBtn();
            }
          });
        },
        {
          threshold: 0.7,
        }
      );

      [...this.sliderList.children].forEach((slide) => {
        sliderScrollObserver.observe(slide);
      });
    }

    scrollList(btn) {
      const direction = btn.getAttribute('data-switch-action');
      const slideWidth = this.slide.getBoundingClientRect().width;
      direction === 'next'
        ? this.sliderList.scrollLeft += slideWidth
        : this.sliderList.scrollLeft -= slideWidth;
      this.visibilityBtn();
    }

    visibilityBtn() {
      const prev = this.buttons[0];
      const next = this.buttons[1];

      // A slider short enough to fit renders no buttons at all.
      if (!prev || !next) return;
      
      setTimeout(() => {
        const firstSlidePosition = this.sliderList.scrollLeft;
        prev.setAttribute("data-active", firstSlidePosition > 0);
      }, 500);

      this.currentIndex === this.size - 1
        ? (next.setAttribute('data-active', 'false'))
        : (next.setAttribute('data-active', 'true'));
    }
  }

  customElements.define('main-slider', MainSlider);
}
